import { useQuery } from '@tanstack/react-query'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper/modules'
import { bannerAPI } from '../../services/api'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import 'swiper/css/effect-fade'

const BannerSlider = () => {
    const { data: bannerData, isLoading } = useQuery({
        queryKey: ['banners', 'universities_page'],
        queryFn: () => bannerAPI.getBanners({ position: 'universities_page', active: true })
    })

    const banners = bannerData?.data?.banners || []

    if (isLoading || banners.length === 0) return null

    return (
        <section className="mb-12">
            <Swiper
                modules={[Autoplay, Pagination, Navigation, EffectFade]}
                effect="fade"
                spaceBetween={0}
                slidesPerView={1}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                pagination={{ clickable: true, dynamicBullets: true }}
                navigation={true}
                loop={banners.length > 1}
                className="rounded-2xl overflow-hidden shadow-xl aspect-[21/9] md:aspect-[3/1]"
            >
                {banners.map((banner) => (
                    <SwiperSlide key={banner._id}>
                        <div className="relative w-full h-full group">
                            <img
                                src={banner.image.url}
                                alt={banner.title}
                                className="w-full h-full object-cover"
                            />
                            {banner.title && (
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent flex items-end p-8 md:p-12">
                                    <div className="text-white max-w-2xl transform transition-transform duration-500 group-hover:translate-x-2">
                                        <h2 className="text-2xl md:text-4xl font-black mb-2 drop-shadow-lg">{banner.title}</h2>
                                        {banner.description && (
                                            <p className="text-sm md:text-lg opacity-90 line-clamp-2 drop-shadow-md">{banner.description}</p>
                                        )}
                                        {banner.link && (
                                            <a
                                                href={banner.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="inline-block mt-4 bg-accent-500 hover:bg-accent-600 text-white px-6 py-2 rounded-full text-sm font-bold transition-all shadow-lg hover:shadow-accent-500/50"
                                                onClick={() => bannerAPI.trackClick(banner._id)}
                                            >
                                                Learn More
                                            </a>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    )
}

export default BannerSlider
